const companyhistory = {
    getlist: 'companyhistory/getlist',
    add: 'companyhistory/add',
    update: 'companyhistory/update',
    remove: 'companyhistory/remove',
    get: 'companyhistory/get',
    getall: 'companyhistory/getall',
}
export default companyhistory